
const avatarGradients = [
  'linear-gradient(135deg, #5ca9fb, #6372ff)',
  'linear-gradient(135deg, #f093fb, #f5576c)',
  'linear-gradient(135deg, #43e97b, #38f9d7)',
  'linear-gradient(135deg, #fa709a, #fee140)',
  'linear-gradient(135deg, #4facfe, #00f2fe)',
  'linear-gradient(135deg, #a18cd1, #fbc2eb)',
  'linear-gradient(135deg, #fd7443, #f9b93a)',
  'linear-gradient(135deg, #30cfd0, #330867)',
  'linear-gradient(135deg, #667eea, #764ba2)',
];

export const Testimonials = (props) => {
  const rating = props.contact?.rating || '4.5';
  const reviewCount = props.contact?.reviewCount || '105';

  // Hide section if no reviews loaded yet
  if (!props.data || props.data.length === 0) return null;

  return (
    <section id='testimonials' style={{ padding: '100px 0', background: '#0a0a14' }}>
      <div className='container'>

        {/* ── Section Header ── */}
        <div style={{ textAlign: 'center', marginBottom: '64px' }}>
          <p style={{
            color: '#5ca9fb', fontWeight: '700',
            fontSize: '12px', letterSpacing: '3px',
            textTransform: 'uppercase', margin: '0 0 16px',
          }}>
            — Client Testimonials
          </p>
          <h2 style={{
            fontFamily: 'Raleway, sans-serif',
            fontSize: 'clamp(32px, 4vw, 52px)',
            fontWeight: '800', color: '#fff',
            lineHeight: '1.1', margin: '0 0 48px',
          }}>
            What Our Clients&nbsp;
            <span style={{ color: '#5ca9fb' }}>Say</span>
          </h2>

          {/* ── Google Rating Hero ── */}
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '32px',
            background: 'rgba(255,255,255,0.04)',
            border: '1px solid rgba(255,255,255,0.09)',
            borderRadius: '20px',
            padding: '28px 40px',
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}>
            {/* Big rating number */}
            <div style={{ textAlign: 'center' }}>
              <div style={{
                fontFamily: 'Raleway, sans-serif',
                fontSize: '72px', fontWeight: '900',
                color: '#fff', lineHeight: 1,
                letterSpacing: '-2px',
              }}>
                {rating}
              </div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '1px', marginTop: '6px' }}>
                out of 5
              </div>
            </div>

            {/* Divider */}
            <div style={{ width: '1px', height: '60px', background: 'rgba(255,255,255,0.1)' }} />

            {/* Stars + count */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', marginBottom: '8px' }}>
                {[1,2,3,4].map(n => (
                  <svg key={n} width='22' height='22' viewBox='0 0 24 24' fill='#FFB800'>
                    <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/>
                  </svg>
                ))}
                <svg width='22' height='22' viewBox='0 0 24 24'>
                  <defs>
                    <linearGradient id='halfStar' x1='0' x2='1' y1='0' y2='0'>
                      <stop offset='50%' stopColor='#FFB800'/>
                      <stop offset='50%' stopColor='rgba(255,255,255,0.15)'/>
                    </linearGradient>
                  </defs>
                  <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' fill='url(#halfStar)'/>
                </svg>
              </div>
              <div style={{ color: '#fff', fontSize: '15px', fontWeight: '700' }}>
                {reviewCount} Google Reviews
              </div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px', marginTop: '3px' }}>
                Verified customer feedback
              </div>
            </div>

            {/* Divider */}
            <div style={{ width: '1px', height: '60px', background: 'rgba(255,255,255,0.1)' }} className='rating-divider' />

            {/* Google badge */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px', justifyContent: 'center' }}>
                <svg width='22' height='22' viewBox='0 0 24 24'>
                  <path fill='#4285F4' d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z'/>
                  <path fill='#34A853' d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z'/>
                  <path fill='#FBBC05' d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z'/>
                  <path fill='#EA4335' d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z'/>
                </svg>
                <span style={{ color: '#fff', fontSize: '15px', fontWeight: '700' }}>Google</span>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: '12px' }}>
                Business Profile
              </div>
            </div>
          </div>
        </div>

        {/* ── Review Cards Grid ── */}
        <div className='testimonials-grid'>
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.07)',
                    borderRadius: '18px',
                    padding: '28px',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'border-color 0.3s, transform 0.3s',
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor = 'rgba(92,169,251,0.35)';
                    e.currentTarget.style.transform = 'translateY(-4px)';
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.07)';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}
                >
                  {/* Decorative large quote mark */}
                  <span style={{
                    position: 'absolute',
                    top: '-10px', right: '16px',
                    fontFamily: 'Georgia, serif',
                    fontSize: '100px', fontWeight: '900',
                    color: 'rgba(92,169,251,0.08)',
                    lineHeight: 1,
                    userSelect: 'none', pointerEvents: 'none',
                  }}>
                    "
                  </span>

                  {/* Stars */}
                  <div style={{ display: 'flex', gap: '3px', marginBottom: '16px' }}>
                    {[1,2,3,4,5].map(n => (
                      <svg key={n} width='16' height='16' viewBox='0 0 24 24' fill={n <= (d.rating || 5) ? '#FFB800' : 'rgba(255,255,255,0.15)'}>
                        <path d='M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z'/>
                      </svg>
                    ))}
                  </div>

                  {/* Review text */}
                  <p style={{
                    color: 'rgba(255,255,255,0.65)',
                    fontSize: '14px',
                    lineHeight: '1.8',
                    margin: '0 0 24px',
                    flex: 1,
                    fontStyle: 'italic',
                  }}>
                    "{d.text}"
                  </p>

                  {/* Reviewer row */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    paddingTop: '18px',
                    borderTop: '1px solid rgba(255,255,255,0.07)',
                  }}>
                    {/* Avatar + name */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      {d.photo ? (
                        <img
                          src={d.photo}
                          alt={d.name}
                          referrerPolicy='no-referrer'
                          style={{
                            width: '38px', height: '38px',
                            borderRadius: '50%',
                            objectFit: 'cover',
                            flexShrink: 0,
                          }}
                        />
                      ) : (
                        <div style={{
                          width: '38px', height: '38px',
                          borderRadius: '50%',
                          background: avatarGradients[i % avatarGradients.length],
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          flexShrink: 0,
                          fontFamily: 'Raleway, sans-serif',
                          fontSize: '15px', fontWeight: '800',
                          color: '#fff',
                        }}>
                          {d.name.charAt(0)}
                        </div>
                      )}
                      <div>
                        <div style={{
                          color: '#fff',
                          fontSize: '13px',
                          fontWeight: '700',
                          fontFamily: 'Raleway, sans-serif',
                        }}>
                          {d.name}
                        </div>
                        <div style={{ color: 'rgba(255,255,255,0.35)', fontSize: '11px', marginTop: '1px' }}>
                          Verified Customer
                        </div>
                      </div>
                    </div>

                    {/* Google icon badge */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '5px',
                      padding: '5px 10px',
                      borderRadius: '20px',
                      background: 'rgba(255,255,255,0.06)',
                      border: '1px solid rgba(255,255,255,0.1)',
                      flexShrink: 0,
                    }}>
                      <svg width='13' height='13' viewBox='0 0 24 24'>
                        <path fill='#4285F4' d='M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z'/>
                        <path fill='#34A853' d='M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z'/>
                        <path fill='#FBBC05' d='M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z'/>
                        <path fill='#EA4335' d='M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z'/>
                      </svg>
                      <span style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px', fontWeight: '600' }}>
                        Google
                      </span>
                    </div>
                  </div>
                </div>
              ))
            : 'Loading...'}
        </div>

        {/* ── Bottom CTA ── */}
        <div style={{
          marginTop: '64px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '24px',
          textAlign: 'center',
        }}>
          <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '15px', margin: 0 }}>
            Join {reviewCount}+ happy clients across Lagos.{' '}
            <strong style={{ color: 'rgba(255,255,255,0.7)' }}>
              Share your experience or read all reviews.
            </strong>
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', justifyContent: 'center' }}>
            <a
              href='https://www.google.com/maps/search/?api=1&query=ACTECH+Air+conditioning+Services+103+Olaitan+Odularu+St+Surulere+Lagos'
              target='_blank'
              rel='noopener noreferrer'
              className='test-btn'
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                background: 'linear-gradient(to right, #5ca9fb, #6372ff)',
                color: '#fff', padding: '13px 28px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                boxShadow: '0 8px 24px rgba(92,169,251,0.35)',
              }}
            >
              <i className='fa fa-google'></i> Read All Reviews
            </a>
            <a
              href='https://www.google.com/maps/search/?api=1&query=ACTECH+Air+conditioning+Services+103+Olaitan+Odularu+St+Surulere+Lagos#writereview'
              target='_blank'
              rel='noopener noreferrer'
              className='test-btn'
              style={{
                display: 'inline-flex', alignItems: 'center', gap: '8px',
                color: '#fff', padding: '13px 28px', borderRadius: '50px',
                textDecoration: 'none', fontWeight: '700', fontSize: '13px',
                textTransform: 'uppercase', letterSpacing: '0.5px',
                border: '2px solid rgba(255,255,255,0.18)',
              }}
            >
              <i className='fa fa-star'></i> Write a Review
            </a>
          </div>
        </div>

      </div>

      <style>{`
        .testimonials-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 18px;
        }

        /* Reset FA icon blob styles */
        #testimonials .test-btn i.fa {
          font-size: 14px !important;
          width: auto !important;
          height: auto !important;
          padding: 0 !important;
          border-radius: 0 !important;
          background: none !important;
          box-shadow: none !important;
          margin-bottom: 0 !important;
          color: inherit !important;
          display: inline !important;
          transition: none !important;
          line-height: inherit !important;
        }

        @media (max-width: 900px) {
          .testimonials-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
          .rating-divider {
            display: none !important;
          }
        }

        @media (max-width: 560px) {
          .testimonials-grid {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>
  );
};
